import { Client } from './Client';
import { ClientAddress } from './ClientAddress';
import { OrderItem } from './OrderItem';
import { User } from './User';

export interface Order {
  id: number;
  businessName: string | null;
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  notes: string | null;
  dateCreated: string | null;
  orderStatusId: number | null;
  userId: number | null;
  billingAddressId: number | null;
  shippingAddressId: number | null;
  dateSubmitted: string | null;
  ponumber: string | null;
  clientId: number | null;
  shippingMethodId: number | null;

  client: Client | null;
  orderItems: OrderItem[] | null;
  billingAddress: ClientAddress | null;
  shippingAddress: ClientAddress | null;
  user: User | null;
}

export enum OrderStatusEnums {
  Open = 1,
  Submitted = 2,
}

export enum OrderStatusStringEnums {
  'Unknown' = 0,
  'Open' = 1,
  'Submitted' = 2,
}
